import { DataService } from "../data.service";

export class OSSObject {

    public dataService:DataService

    constructor() {
  
    }
    
  }